export default __webpack_public_path__ + "static/media/EmptyCart.a7821ebc.png";